import { render, staticRenderFns } from "./SaldoMonederoComponent.vue?vue&type=template&id=9494d916&scoped=true"
import script from "./SaldoMonederoComponent.vue?vue&type=script&lang=js"
export * from "./SaldoMonederoComponent.vue?vue&type=script&lang=js"
import style0 from "./SaldoMonederoComponent.vue?vue&type=style&index=0&id=9494d916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9494d916",
  null
  
)

export default component.exports